export default "__VITE_ASSET__BwNYXatj__"